import Vue from 'vue';
import Router from 'vue-router';
import Index from './pages/Index.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import DynamicContent from "./pages/DynamicContent";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'index',
            components: {default: Index, header: MainNavbar, footer: MainFooter},
            props: {
                header: {colorOnScroll: 200},
                footer: {backgroundColor: 'black'}
            }
        },
        {
            path: '/registrering',
            beforeEnter(to, from, next) {
                // Put the full page url including the protocol http(s) below
                console.log('REG::: ', router.app.$store.state.config.signupUrl)
                window.location = router.app.$store.state.config.signupUrl
            }
        },
        {
            path: '/facebook',
            beforeEnter(to, from, next) {
                // Put the full page url including the protocol http(s) below
                window.location = router.app.$store.state.config.facebookEventUrl
            }
        },
        {
            path: '/:slug',
            name: 'dynamic',
            components: {default: DynamicContent, header: MainNavbar, footer: MainFooter},
            props: {
                header: {colorOnScroll: 0},
                footer: {backgroundColor: 'black', type: 'fixed'}
            }
        },
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    }
});

export default router